export default "__VITE_ASSET__CzoFtsdT__"